// @ts-nocheck
import useAppSelector from "@insite/client-framework/Common/Hooks/useAppSelector";
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import { SafeDictionary } from "@insite/client-framework/Common/Types";
import { useShellContext } from "@insite/client-framework/Components/IsInShell";
import { PageLinkModel } from "@insite/client-framework/Services/ContentService";
import siteMessage from "@insite/client-framework/SiteMessage";
import { getPageLinkByNodeId } from "@insite/client-framework/Store/Links/LinksSelectors";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import Typography, { TypographyProps } from "@insite/mobius/Typography";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import constants from "@store/constants";
import { useBlogCategoryArticlesDataView } from "@store/Framework/Store/Data/BlogCategory/BlogCategoryHooks";
import BlogCategoryArticlesListPagination, {
    BlogCategoryArticlesListPaginationPresentationProps,
} from "@store/Library/Components/Toolkit/Blog/BlogCategoryArticlesListPagination";
import BlogTileList, { BlogTileListPresentationProps } from "@store/Library/Components/Toolkit/Blog/BlogTileList";
import DataViewLoadingOverlay from "@store/Library/Components/Toolkit/DataViewLoadingOverlay";
import { LoadingOverlayProps } from "@store/MobiusOverrides/LoadingOverlay/LoadingOverlay";
import { typographyGetNoResultsProps } from "@store/Themes/common/props/typography";
import usePersistentDataView from "@toolkit/Framework/Common/Hooks/usePersistentDataView";
import * as React from "react";
import { FC } from "react";

interface BlogCategoryArticlesListProps extends WidgetProps {}

export interface BlogCategoryArticlesListStyles {
    loadingOverlay?: LoadingOverlayProps;
    noResultsContainer?: InjectableCss;
    noResultsText?: TypographyProps;
    blogTileList?: BlogTileListPresentationProps;
    blogCategoryArticlesListPagination?: BlogCategoryArticlesListPaginationPresentationProps;
}

export const blogCategoryArticlesListStyles: BlogCategoryArticlesListStyles = {
    noResultsText: typographyGetNoResultsProps(),
    blogTileList: {
        extendedStyles: {
            blogTile: {
                extendedStyles: {
                    title: {
                        forwardAs: "h2",
                    },
                },
            },
        },
    },
};

const styles = blogCategoryArticlesListStyles;

const BlogCategoryArticlesList: FC<BlogCategoryArticlesListProps> = () => {
    const { isInShell } = useShellContext();
    const baseBlogArticlesDataView = useBlogCategoryArticlesDataView(isInShell);
    const blogArticlesDataView = usePersistentDataView(baseBlogArticlesDataView);
    const { value: articles } = blogArticlesDataView;

    const links: SafeDictionary<PageLinkModel> =
        useAppSelector(state =>
            articles?.reduce(
                (links, page) => ({
                    ...links,
                    [page.nodeId]: getPageLinkByNodeId(state, page.nodeId),
                    [page.parentId]: getPageLinkByNodeId(state, page.parentId),
                }),
                {},
            ),
        ) || {};

    return (
        <DataViewLoadingOverlay {...styles.loadingOverlay} dataView={blogArticlesDataView}>
            {!articles?.length ? (
                <StyledWrapper {...styles.noResultsContainer}>
                    <Typography {...styles.noResultsText}>{siteMessage("Blog_Category_Articles_Not_Found")}</Typography>
                </StyledWrapper>
            ) : (
                <>
                    <BlogTileList {...styles.blogTileList} articles={articles} articlesLinks={links} />
                    <BlogCategoryArticlesListPagination {...styles.blogCategoryArticlesListPagination} />
                </>
            )}
        </DataViewLoadingOverlay>
    );
};

const widgetModule: WidgetModule = {
    component: BlogCategoryArticlesList,
    definition: {
        group: constants.widgetGroup.blog,
        allowedContexts: [constants.pageType.blogCategoryPage],
        displayName: "Articles List",
    },
};

export default widgetModule;
